export default () => ({
  flags: null
})
